import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import vumsa from "../../Assets/Projects/vumsa.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import barber from "../../Assets/Projects/barber.png";
import hallink from "../../Assets/Projects/hallink.png";
import quiz from "../../Assets/Projects/quiz.png";
import exchange from "../../Assets/Projects/exchange.png";
import country from "../../Assets/Projects/country.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hallink}
              isBlog={true}
              title="Hallink"
              description="a sleek app that combines all your social media links into one place. Inspired by the Somali word for 'One Link' Hallink lets creators, entrepreneurs, and connectors share their online world with just one tap. Say goodbye to scattered links and hello to effortless connection! 🚀 Try Hallink now and simplify your socials!"
              ghLink=""
              demoLink="https://www.hallink.ink/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={vumsa}
              isBlog={true}
              title="Vumsa.Online"
              description="The VUMSA website,built with React.js and Firebase, is a responsive platform for Victoria University’s Muslim community, offering prayer times, event listings, daily Hadith and Quran verses, user profiles, an e-commerce marketplace for Muslim outfits, Islamic resources, secure donations, community statistics, and an admin dashboard to manage content and engagement, fostering faith and connection in a streamlined hub."
              ghLink=""
              demoLink="https://vumsa.online"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={barber}
              isBlog={true}
              title="Barber App"
              description="this platform enables users to book barber appointments, select services and times, and receive digital receipts, with secure authentication. Admins manage bookings via a dashboard. The landing page highlights services, locations, and WhatsApp contact for easy engagement."
              ghLink="https://github.com/bisharr/barberApplicationo"
              demoLink="https://barber-application-fawn.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={quiz}
              isBlog={false}
              title="General Quiz app"
              description="A general quiz app that has authentications, and gives you some questions with option to choose in 5 minutes time and counts the user has the highest points"
              ghLink="https://github.com/bisharr/GeneralQuizApp"
              demoLink="https://general-quiz-app-sable.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={exchange}
              isBlog={false}
              title="Currency exchange app"
              description="an app that access you to change any currency with realtime"
              ghLink="https://github.com/bisharr/currency-converter"
              demoLink="https://currencyconverterbis.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={country}
              isBlog={false}
              title="Search Country"
              description="small app that you can search any country in world just typing some real facts about that country.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              ghLink="https://github.com/bisharr/search-Country"
              demoLink="https://searchcountry0.netlify.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
